<template>
  <transition name="fade">
    <small class="text-danger" v-if="text">{{ text[0] !== undefined ? text[0] : text }}</small>
  </transition>
</template>

<script>
export default {
  name: "error-text",
  props: {
    text: [Array, String],
  }
}
</script>

<style scoped>
.text-danger {
  color: #E05252;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>